import { c as _c } from "react/compiler-runtime";
import { useDate, useDestination, useHistory, usePassengerCount, useSubmit, useValidation } from "@website/accommodation-ui/hotel-search/hotel-search-panel/hooks";
import { HotelSearchPanelPropertiesType } from "@website/accommodation-ui/hotel-search/hotel-search-panel/hotel-search-panel.types";
import { MaterialIcon } from "@website/icons/material";
import { AutoComplete } from "@website/ui/auto-complete";
import { Button } from "@website/ui/button";
import { Datepicker } from "@website/ui/datepicker";
import isEmpty from "lodash-es/isEmpty";
import { FC } from "react";
export const HotelSearchPanel: FC<HotelSearchPanelPropertiesType> = properties => {
  const $ = _c(81);
  const {
    size,
    searchType,
    initialCityData,
    onClose,
    passengerCountInitialValues,
    datePickerInitialValues,
    handleSearchSubmit,
    searchSuggestion,
    searchAutocompleteFetcher,
    landingSearch,
    source,
    hasBorder,
    hasWhiteBg,
    hasPlaceHolder,
    searchBtnClassName,
    destinationPlaceholder,
    hasBtnClose: t0,
    isFloatCloseButton: t1,
    hasTitle: t2,
    requireDates: t3,
    requireDestinationCoordinates
  } = properties;
  const hasButtonClose = t0 === undefined ? true : t0;
  const isFloatCloseButton = t1 === undefined ? true : t1;
  const hasTitle = t2 === undefined ? true : t2;
  const requireDates = t3 === undefined ? true : t3;
  const {
    passengerCount
  } = usePassengerCount(passengerCountInitialValues);
  const t4 = initialCityData?.title;
  let t5;
  if ($[0] !== destinationPlaceholder || $[1] !== hasPlaceHolder || $[2] !== searchAutocompleteFetcher || $[3] !== searchSuggestion || $[4] !== t4) {
    t5 = {
      cityTitleInitialValues: t4,
      searchSuggestion,
      searchAutocompleteFetcher,
      hasPlaceHolder,
      destinationPlaceholder
    };
    $[0] = destinationPlaceholder;
    $[1] = hasPlaceHolder;
    $[2] = searchAutocompleteFetcher;
    $[3] = searchSuggestion;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const {
    selectedDestinationItem,
    selectedDestinationText,
    destinationQuery,
    onChangeDestination,
    onChangeDestinationQuery,
    onSelectDestination,
    destinationLoading,
    destinationListNormalized,
    DestinationNoResult
  } = useDestination(t5);
  const {
    date,
    onChangeDate
  } = useDate(datePickerInitialValues);
  const {
    historyListNormalized,
    addToHistory,
    onSelectHistory
  } = useHistory(onChangeDestination, requireDestinationCoordinates);
  let t6;
  if ($[6] !== date || $[7] !== initialCityData || $[8] !== requireDates || $[9] !== searchType || $[10] !== selectedDestinationItem) {
    t6 = {
      selectedDestinationItem,
      date,
      initialDestinationItem: initialCityData,
      requireDates,
      searchType
    };
    $[6] = date;
    $[7] = initialCityData;
    $[8] = requireDates;
    $[9] = searchType;
    $[10] = selectedDestinationItem;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const {
    destinationError,
    dateError,
    submitValidationCheck
  } = useValidation(t6);
  const {
    onSubmitClick,
    submitLoading
  } = useSubmit(selectedDestinationItem, date, passengerCount, addToHistory, submitValidationCheck, handleSearchSubmit, initialCityData, requireDates);
  const t7 = `${searchType === "hotel" ? "gap-8" : "gap-6"} ${source === "nowrouzLanding" && hasBorder && "border-primary border"} ${hasWhiteBg && "bg-white"} ${source === "nowrouzLanding" ? "shadow-6 h-auto rounded-[16px] p-3 pr-2" : "h-full lg:h-auto"} relative mb-4 flex flex-col lg:mb-0`;
  let t8;
  if ($[12] !== hasTitle || $[13] !== landingSearch || $[14] !== searchType) {
    t8 = !landingSearch && <h3 className={`${hasTitle ? "block" : "hidden"} text-headline-6 lg:hidden`}>{searchType === "hotel" ? "\u062A\u0639\u06CC\u06CC\u0646 \u0628\u0627\u0632\u0647 \u0627\u0642\u0627\u0645\u062A" : "\u0647\u062A\u0644"}</h3>;
    $[12] = hasTitle;
    $[13] = landingSearch;
    $[14] = searchType;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = `flex flex-col gap-4 xl:flex-row ${searchType === "hotel" ? "w-full" : ""}`;
  const t10 = `flex gap-4 lg:flex-row ${searchType === "city" ? "flex-1" : "w-full lg:items-center"} ${source === "nowrouzLanding" ? "flex-row flex-wrap" : "flex-col"} `;
  let t11;
  if ($[16] !== DestinationNoResult || $[17] !== destinationError || $[18] !== destinationListNormalized || $[19] !== destinationLoading || $[20] !== destinationPlaceholder || $[21] !== destinationQuery || $[22] !== historyListNormalized || $[23] !== onChangeDestinationQuery || $[24] !== onSelectDestination || $[25] !== onSelectHistory || $[26] !== searchType || $[27] !== selectedDestinationText || $[28] !== size || $[29] !== source) {
    t11 = searchType !== "hotel" && <div className={`${source === "nowrouzLanding" ? "flex-[1.2]" : "flex-[3]"} ${searchType === "category" ? "pointer-events-none opacity-60" : ""}`}><AutoComplete disabled={!isEmpty(destinationPlaceholder)} error={destinationError} fullWidth={true} hasDropdownIcon={source === "nowrouzLanding"} hideBorder={source === "nowrouzLanding"} hideStartIcon={source === "nowrouzLanding"} inputClassName={source === "nowrouzLanding" ? "placeholder:text-black pt-1 " : undefined} labelClassName={source === "nowrouzLanding" ? "pt-4" : ""} parts={[{
        label: source === "nowrouzLanding" ? "\u0645\u0642\u0635\u062F" : "\u0634\u0647\u0631 \u06CC\u0627 \u0647\u062A\u0644 \u0645\u0642\u0635\u062F",
        list: DestinationNoResult ? [] : destinationListNormalized,
        historyList: !DestinationNoResult && !destinationLoading ? historyListNormalized : [],
        historyTitle: "\u062C\u0633\u062A\u062C\u0648 \u0647\u0627\u06CC \u0627\u062E\u06CC\u0631",
        text: selectedDestinationText || "",
        onSelect: onSelectDestination,
        onSelectHistory,
        onChangeQuery: onChangeDestinationQuery,
        query: destinationQuery,
        loading: destinationLoading,
        NoResult: DestinationNoResult
      }]} size={size} /></div>;
    $[16] = DestinationNoResult;
    $[17] = destinationError;
    $[18] = destinationListNormalized;
    $[19] = destinationLoading;
    $[20] = destinationPlaceholder;
    $[21] = destinationQuery;
    $[22] = historyListNormalized;
    $[23] = onChangeDestinationQuery;
    $[24] = onSelectDestination;
    $[25] = onSelectHistory;
    $[26] = searchType;
    $[27] = selectedDestinationText;
    $[28] = size;
    $[29] = source;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  const t12 = `${searchType === "hotel" ? "flex-auto lg:max-w-[312px]" : "flex-[2]"}`;
  const t13 = dateError.length > 0;
  const t14 = searchType === "hotel" ? "0px" : "-16px";
  const t15 = searchType === "hotel" ? "42px" : "-16px";
  const t16 = source === "nowrouzLanding";
  const t17 = source === "nowrouzLanding";
  const t18 = source === "nowrouzLanding" ? "placeholder:text-black" : undefined;
  const t19 = source === "nowrouzLanding" ? "pt-4" : "";
  let t20;
  if ($[31] !== source) {
    t20 = source === "nowrouzLanding" ? ["top", "bottom", "start", "end"] : undefined;
    $[31] = source;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  const t21 = searchType === "hotel" ? "start" : "end";
  const t22 = searchType === "hotel" ? "dense" : "default";
  let t23;
  if ($[33] !== date) {
    t23 = date ?? [];
    $[33] = date;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] !== dateError || $[36] !== onChangeDate || $[37] !== onSubmitClick || $[38] !== t13 || $[39] !== t14 || $[40] !== t15 || $[41] !== t16 || $[42] !== t17 || $[43] !== t18 || $[44] !== t19 || $[45] !== t20 || $[46] !== t21 || $[47] !== t22 || $[48] !== t23) {
    t24 = <Datepicker error={t13} fromTitle={"\u062A\u0627\u0631\u06CC\u062E \u0648\u0631\u0648\u062F"} fullWidth={true} gapHorizontal={t14} gapVertical={t15} hasDropdownIcon={t16} helperText={dateError} hideMiddleLine={t17} inputClassName={t18} labelClassName={t19} mode="range" noBorder={t20} onChange={onChangeDate} ctaAcceptClick={onSubmitClick} position={t21} size={t22} toTitle={"\u062A\u0627\u0631\u06CC\u062E \u062E\u0631\u0648\u062C"} value={t23} />;
    $[35] = dateError;
    $[36] = onChangeDate;
    $[37] = onSubmitClick;
    $[38] = t13;
    $[39] = t14;
    $[40] = t15;
    $[41] = t16;
    $[42] = t17;
    $[43] = t18;
    $[44] = t19;
    $[45] = t20;
    $[46] = t21;
    $[47] = t22;
    $[48] = t23;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  let t25;
  if ($[50] !== t12 || $[51] !== t24) {
    t25 = <div className={t12}>{t24}</div>;
    $[50] = t12;
    $[51] = t24;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  const t26 = `w-full ${searchBtnClassName}${source === "nowrouzLanding" ? "relative md:w-[134px]" : "absolute bottom-0 lg:relative lg:w-[134px]"}`;
  const t27 = searchType === "hotel" ? "secondary" : "primary";
  const t28 = searchType === "hotel" ? "medium" : "x-large";
  const t29 = landingSearch ? "\u062C\u0633\u062A\u062C\u0648" : "\u0628\u0631\u0648\u0632\u0631\u0633\u0627\u0646\u06CC \u062C\u0633\u062A\u062C\u0648";
  let t30;
  if ($[53] !== onSubmitClick || $[54] !== submitLoading || $[55] !== t27 || $[56] !== t28 || $[57] !== t29) {
    t30 = <Button color={t27} fullWidth={true} loading={submitLoading} onClick={onSubmitClick} size={t28}>{t29}</Button>;
    $[53] = onSubmitClick;
    $[54] = submitLoading;
    $[55] = t27;
    $[56] = t28;
    $[57] = t29;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== t26 || $[60] !== t30) {
    t31 = <div className={t26}>{t30}</div>;
    $[59] = t26;
    $[60] = t30;
    $[61] = t31;
  } else {
    t31 = $[61];
  }
  let t32;
  if ($[62] !== hasButtonClose || $[63] !== isFloatCloseButton || $[64] !== landingSearch || $[65] !== onClose || $[66] !== searchType) {
    t32 = landingSearch ? null : hasButtonClose && <div className={`absolute left-0 mr-auto hidden text-center lg:block ltr:ml-auto ${searchType === "hotel" ? "xl:mt-0" : ""} ${isFloatCloseButton && "-top-10"}`}><Button StartIcon={<MaterialIcon name="close" />} color="neutral" onClick={onClose} size="small" variant="text" /></div>;
    $[62] = hasButtonClose;
    $[63] = isFloatCloseButton;
    $[64] = landingSearch;
    $[65] = onClose;
    $[66] = searchType;
    $[67] = t32;
  } else {
    t32 = $[67];
  }
  let t33;
  if ($[68] !== t10 || $[69] !== t11 || $[70] !== t25 || $[71] !== t31 || $[72] !== t32) {
    t33 = <div className={t10}>{t11}{t25}{t31}{t32}</div>;
    $[68] = t10;
    $[69] = t11;
    $[70] = t25;
    $[71] = t31;
    $[72] = t32;
    $[73] = t33;
  } else {
    t33 = $[73];
  }
  let t34;
  if ($[74] !== t33 || $[75] !== t9) {
    t34 = <div className={t9}>{t33}</div>;
    $[74] = t33;
    $[75] = t9;
    $[76] = t34;
  } else {
    t34 = $[76];
  }
  let t35;
  if ($[77] !== t34 || $[78] !== t7 || $[79] !== t8) {
    t35 = <div className={t7}>{t8}{t34}</div>;
    $[77] = t34;
    $[78] = t7;
    $[79] = t8;
    $[80] = t35;
  } else {
    t35 = $[80];
  }
  return t35;
};